import { useParams } from "react-router-dom";
import { articles } from "../content/articles";
import { Helmet } from "react-helmet-async";
import { useEffect } from "react";
import "../content/articles/articles.css";
import { Link } from "react-router-dom";


export default function ArticlePage() {
  const { slug } = useParams();

  useEffect(() => {
  if (window.location.hash) {
    const el = document.querySelector(window.location.hash);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
      return;
    }
  }
  window.scrollTo(0, 0);
}, [slug]);


  const article = articles.find(a => a.slug === slug);

  if (!article) {
    return (
      <>
        <Helmet>
          <title>Article Not Found | Venura Consultants</title>
          <meta name="robots" content="noindex" />
        </Helmet>

        <div className="container mx-auto px-6 py-24">
          <h1 className="text-3xl font-bold">404 – Article not found</h1>
          <p className="mt-4">
            The article you’re looking for doesn’t exist or has been moved.
          </p>
        </div>
      </>
    );
  }

  const { title, excerpt, Component } = article;

return (
  <>
    <Helmet>
      <title>{title} | Venura Consultants</title>
      <meta name="description" content={excerpt} />
      <meta name="robots" content="index, follow" />
      <link
        rel="canonical"
        href={`https://www.venuraconsultants.com/resources/${slug}`}
      />
    </Helmet>

    {Component ? <Component /> : (
      <div className="container mx-auto px-6 py-24">
        <h1 className="text-2xl font-bold">Article rendering error</h1>
      </div>
    )}
  </>
);

}
